"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyContactDetailsCardCms = void 0;
var CompanyContactDetailsCardCms = /** @class */ (function () {
    function CompanyContactDetailsCardCms() {
        this.fieldDetailsLabel = 'All fields are optional.';
        this.fullNameLabel = 'Landlord\'s full name';
        this.fullNamePlaceholderTxt = 'First & last name';
        this.companyNameLabel = 'Property management company';
        this.phoneNumberLabel = 'Landlord\'s phone number';
        this.phoneNumberPlaceholderTxt = '10 digits';
        this.emailLabel = 'Landlord\'s email';
        this.fullNameInvalidErrTxt = 'Invalid full name';
        this.phoneNumberInvalidErrTxt = 'Invalid phone number';
        this.phoneNumberErrTxt = 'Enter a 10-digit number';
        this.emailErrTxt = 'Enter a valid email address';
    }
    return CompanyContactDetailsCardCms;
}());
exports.CompanyContactDetailsCardCms = CompanyContactDetailsCardCms;
//# sourceMappingURL=companycontactdetailscard.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/cards/WorkServiceConflictCard/CompanyContactDetailsCard/companycontactdetailscard.cms.js
// module id = 1979
// module chunks = 8